import * as Scrivito from "scrivito";
import parse from "html-react-parser";
import EventDate from "^/Components/Events/EventDate";
import I18n from "^/config/i18n";

function EventData({ event, weight }) {
  return (
    <div
      className="col-md-6 event-overview__event-node no-image mb-3"
      data-weight={weight}
    >
      <div className="row mx-0 event-overview__event-data">
        <div className="py-3 px-1 col-md-4 bg-lighter-gray text-orange event-overview__event-node--date">
          <EventDate event={event} />
        </div>
        <div className="col-md-8 p-3">
          <h3 className="m-0">
            <Scrivito.LinkTag to={event} className="text-graymiddle">
              {event.get("title")}
            </Scrivito.LinkTag>
          </h3>
          <div className="py-2 text-orange">
            <i className="las la-map-marker me-2" />
            <span className="event-location-name">
              {parse(event.get("locationName"))}
            </span>{" "}
            {event.get("locationName") && event.get("locationRoom") && (
              <span> | </span>
            )}
            <Scrivito.ContentTag
              tag="span"
              content={event}
              itemProp="streetAddress"
              attribute="locationRoom"
            />
          </div>
          <Scrivito.ContentTag
            tag="div"
            content={event}
            attribute="description"
            className="pb-2 event-overview__event-data-description"
          />
          <Scrivito.LinkTag to={event}>
            <i className="las la-angle-right" /> {I18n.t("General see more")}
          </Scrivito.LinkTag>
        </div>
      </div>
    </div>
  );
}
export default Scrivito.connect(EventData);
